import { SubjectData } from 'shell/models/person';
import { ActManagementForm } from 'shell/view-models/act-form';
import { ActType } from 'shell/constants/act-type';
import { DateTime } from 'luxon';
import { transformCivilUnion } from './civil-union';
import { AccordionCivilUnion } from 'shell/view-models/accordion-civil-union';

export type AccordionCivilUnionAnpr05 = Omit<AccordionCivilUnion, 'digital'> & ActManagementForm;

export const transformCivilUnionActAnpr05 = (
  person: SubjectData
): AccordionCivilUnionAnpr05 | undefined => {
  const civilUnion = transformCivilUnion(person);

  const isDigital = Boolean(person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC);

  const isPaper = Boolean(person.unioneCivile?.attoUnione?.attoEventoANPR?.atto);

  const result = civilUnion
    ? {
        ...civilUnion,
        actType: isDigital
          ? ActType.AttoDigitale
          : isPaper
          ? ActType.AttoCartaceo
          : ActType.SenzaAtto,
        digital: isDigital
          ? {
              documentDate: person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC
                ?.dataFormazioneAtto
                ? DateTime.fromISO(
                    person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC?.dataFormazioneAtto
                  )
                : null,
              idAnsc: person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC?.idANSC || '',
              nationalNumber:
                person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC?.idANSC?.split('-')[1],
              istatCode:
                person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                  ?.codiceIstat || '',
              municipality: {
                id:
                  person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                    ?.codiceIstat || '',
                description:
                  person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                    ?.nomeComune || '',
                province:
                  person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                    ?.siglaProvinciaIstat || '',
              },
              numberMunicipality:
                person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC?.numeroComunale || '',
              year: person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC?.anno || '',
              transcript:
                person.unioneCivile?.attoUnione?.attoEventoANPR?.attoANSC?.trascritto === '1'
                  ? true
                  : false,
            }
          : undefined,
        paper: isPaper
          ? {
              // paper
              actMunicipality: person.unioneCivile?.attoUnione?.attoEventoANPR?.atto
                ?.comuneRegistrazione
                ? {
                    description:
                      person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.comuneRegistrazione
                        ?.nomeComune || '',
                    province:
                      person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.comuneRegistrazione
                        ?.siglaProvinciaIstat || '',
                    id:
                      person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.comuneRegistrazione
                        ?.codiceIstat || '',
                  }
                : undefined,
              actYear: person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.anno || '',
              actNumber: person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.numeroAtto || '',
              actPart: person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.parte || '',
              actSeries: person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.serie || '',
              actVolume: person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.volume || '',
              actDate: person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.dataFormazioneAtto
                ? DateTime.fromISO(
                    person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.dataFormazioneAtto
                  )
                : null,
              transcribed:
                person.unioneCivile?.attoUnione?.attoEventoANPR?.atto?.trascritto === '1'
                  ? true
                  : false,
            }
          : undefined,
      }
    : undefined;

  return result;
};
